import { RealTimeNotes } from "../RealTimeNotes";

export const MobileRealTimeNotes = () => <RealTimeNotes isMobile />;
